import './editor.scss';
import { __ } from '@wordpress/i18n';
import { InspectorControls } from '@wordpress/block-editor';
import { InnerBlocks, useBlockProps } from '@wordpress/block-editor';
import { PanelBody, TextControl, SelectControl } from '@wordpress/components';

const Edit = ({ attributes, setAttributes }) => {
  const { mbModalID, mbModalContentType } = attributes;

  return (
    <>
      <InspectorControls>
        <PanelBody title={__('Modal Settings')}>
          <SelectControl
            label={__('Modal Content Type')}
            help={__(
              'Select what you will like to create. Modal Trigger, or Modal Content.'
            )}
            value={mbModalContentType}
            options={[
              {
                label: 'Trigger',
                value: 'htr-modal-trigger',
              },
              {
                label: 'Content',
                value: 'htr-modal-content',
              },
            ]}
            onChange={(value) => {
              setAttributes({ mbModalContentType: value });
            }}
          />
          <TextControl
            label={__('Content ID')}
            help={__("Match this ID with your Modal's trigger/content.")}
            value={mbModalID}
            onChange={(value) => {
              setAttributes({ mbModalID: value });
            }}
          />
        </PanelBody>
      </InspectorControls>
      <div {...useBlockProps()}>
        <div
          className={
            mbModalContentType === 'htr-modal-content'
              ? `${mbModalContentType}-edit`
              : mbModalContentType
          }
        >
          {mbModalContentType === 'htr-modal-trigger' ? (
            <div className='modal-builder-header'>
              <p>
                <strong>Modal Trigger:</strong> Build your Modal{' '}
                <strong>trigger</strong> below (most commonly, triggers are
                buttons or images).
                <br />
                <small>Note: This text will not show on the front-end.</small>
              </p>
            </div>
          ) : (
            <div className='modal-builder-header'>
              <p>
                <strong>Modal Content:</strong> Build your Modal{' '}
                <strong>content</strong> below.
                <br />
                <small>
                  Note: This text will not show on the front-end. The content
                  below is also grayed out on the editor only. It will not be
                  visible on the fron-tend until the trigger is clicked/tapped.
                </small>
                .
              </p>
            </div>
          )}
          <div>
            <InnerBlocks />
          </div>
        </div>
      </div>
    </>
  );
};

export default Edit;
